import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

const ClassesTable = ({ 
  classes, 
  lazyParams, 
  totalRecords, 
  loading, 
  onPage, 
  onFilter, 
  expandedRows, 
  onRowToggle, 
  openEditDialog, 
  deleteClass,
  user,
  openSectionDialog
}) => {

  const rowExpansionTemplate = (data) => {
    return (
      <div className="bg-gradient-to-r from-slate-50 to-gray-50 border-t border-gray-100 p-8">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl shadow-lg">
              <i className="pi pi-sitemap text-white text-lg"></i>
            </div>
            <div>
              <h4 className="text-xl font-bold text-gray-900">Sections in {data.name}</h4>
              <p className="text-gray-600 mt-1">Manage class sections and student distribution</p>
            </div>
          </div>
          {(user?.role === 'admin' || user?.role === 'teacher') && (
            <button type="button" className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 flex items-center gap-2 font-semibold shadow-lg hover:shadow-xl text-sm"
              onClick={() => openSectionDialog(data)}
            >
              <i className="pi pi-plus text-sm"></i> Add Section
            </button>
          )}
        </div>

        {data.sections && data.sections.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {data.sections.map((section) => (
              <div key={section.id} className="bg-white/90 backdrop-blur-sm rounded-2xl border border-white/30 shadow-lg hover:shadow-xl hover:shadow-indigo-500/10 transition-all duration-300 overflow-hidden group hover:-translate-y-1">
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <h5 className="text-lg font-bold text-gray-900">Section - {section.name}</h5>
                    <p className="text-sm text-gray-600">Students: {section.studentCount || 0}</p>
                  </div>
                    <p className="text-sm text-gray-600">Teacher: {section.teacherName || "Not Provided"}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 bg-white/50 rounded-2xl border-2 border-dashed border-gray-300">
            <div className="mb-6">
              <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                <i className="pi pi-sitemap text-2xl text-gray-400"></i>
              </div>
            </div>
            <h4 className="text-lg font-semibold text-gray-900 mb-3">No sections found</h4>
            <div className="flex justify-center w-full">
              {(user?.role === 'admin' || user?.role === 'teacher') && (
                <button type="button" className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 flex items-center gap-2 font-semibold shadow-lg hover:shadow-xl text-sm"
                  onClick={() => openSectionDialog(data)}
                >
                  <i className="pi pi-plus text-sm"></i> Add Section
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  const actionBody = (rowData) => (
    <div className="flex items-center gap-2">
      <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-sm hover:bg-green-50 text-green-600 border-2 border-green-200 hover:border-green-300 transition-all duration-200"
        onClick={() => openEditDialog(rowData)} tooltip="Edit Class" />
      <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-sm hover:bg-red-50 text-red-600 border-2 border-red-200 hover:border-red-300 transition-all duration-200"
        onClick={() => deleteClass(rowData)} tooltip="Delete Class" />
    </div>
  );

  return (
    <div className="min-h-0">
      <DataTable value={classes} lazy paginator first={lazyParams.first} rows={lazyParams.rows} totalRecords={totalRecords} rowsPerPageOptions={[5, 10, 25]}
        onPage={onPage} onFilter={onFilter} loading={loading} dataKey="id" responsiveLayout="scroll" expandedRows={expandedRows} onRowToggle={onRowToggle}
        rowExpansionTemplate={rowExpansionTemplate} emptyMessage={<div className="p-4">No classes found.</div>}
        header={(
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <h3 className="text-2xl font-bold text-gray-900">Classes Directory</h3>
              {totalRecords > 0 ? (
                <span className="flex items-center px-3 py-1 bg-green-50 text-green-700 rounded-full border border-green-200 text-sm">
                  <i className="pi pi-check-circle mr-2"></i>
                  Total {totalRecords} classes
                </span>
              ) : (
                <span className="flex items-center px-3 py-1 bg-orange-50 text-orange-700 rounded-full border border-orange-200 text-sm">
                  <i className="pi pi-exclamation-triangle mr-2"></i>
                  No classes found
                </span>
              )}
            </div>
          </div>
        )}
      >
        <Column expander style={{ width: '3rem' }} />
        <Column field="name" header="Class Name" sortable />
        <Column field="description" header="Description" />
        <Column header="Sections" body={(row) => row.sections?.length ?? 0} />
        <Column field="totalStudents" header="Students" />
        <Column body={actionBody} header="Actions" style={{ width: 150 }} />
      </DataTable>
    </div>
  );
};

export default ClassesTable;
